<script>
import CalendarContainer from './components/CalendarContainer.vue';
import CalendarDataProvider from './components/CalendarDataProvider.vue';

export default {
    name: 'CalendarApp',
    components: {
        CalendarDataProvider,
        CalendarContainer
    }
};
</script>

<template>
    <CalendarDataProvider>
        <template
            #default="{ date, posts, dateConfig, updateDate, updatePosts }"
        >
            <CalendarContainer
                :date="date"
                :posts="posts"
                :date-config="dateConfig"
                @update-date="updateDate"
                @update-posts="updatePosts"
            />
        </template>
    </CalendarDataProvider>
</template>
